import React from 'react';
import ReactMarkdown from 'react-markdown';
import styles from './PreviewModal.module.css';

const PreviewModal = ({ isOpen, onClose, markdownContent }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h2>Document Preview</h2>
        <div className={styles.previewContainer}>
          <ReactMarkdown>{markdownContent}</ReactMarkdown>
        </div>
        <div className={styles.modalActions}>
          <button onClick={onClose} className={styles.closeButton}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PreviewModal;